import { render, staticRenderFns } from "./ProjectVideo.vue?vue&type=template&id=6d17c18c&scoped=true&"
import script from "./ProjectVideo.vue?vue&type=script&lang=js&"
export * from "./ProjectVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVideo.vue?vue&type=style&index=0&id=6d17c18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d17c18c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
